import {BaseTerms} from "../../infrastructure/models/base-terms";

export class BoxScoresWidgetTerms extends BaseTerms {
  WEB_ALL_STATS_TOGGLE = 'All Stats';
  WEB_LINEUPS_MISSING_GAME_TIME_DECISION_TITLE = "Game Time Decision";
  WEB_BOX_SCORE_FOULED_OUT_INDICATION = "Fouled out";
}
